import React from 'react';
import styles from './styles/message-block.module.css'
import PropTypes from 'prop-types';
import BotMessage from "@/components/chatbot/Layout/messages/BotMessage";
import {hasAnswer} from "@/helpers/Flow";
import UserMessage from "@/components/chatbot/Layout/messages/UserMessage";

const MessageBlock = props => {
    const {block} = props;
    return (
        <div className={styles.wrapper}>
            <BotMessage isActive={props.isActive} block={block}/>
            {hasAnswer(block) && <UserMessage block={block}/>}
        </div>
    );
};

MessageBlock.propTypes = {
    isActive: PropTypes.bool.isRequired,
    block: PropTypes.object
};

export default MessageBlock;